/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import NewContentList from "./NewContentList";

// import Event202104_contentList from "./Event202104_contentList";
// import parse from "html-react-parser";
//import '../../css/event20210317.css'
import "../../css/event210521.css";
import "../../css/event210629.css";
import "../../css/event210819.css";
// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import Slider from "react-slick";
import { isMobile } from "react-device-detect";
import $ from "jquery";

class Event202106_shop extends Component {
  state = {
    eventCode: 0,
    tabIndex: 2,
  };
  componentDidMount = () => {
    this._getWindowSize();
  };
  _getWindowSize = () => {
    $("img[usemap]").rwdImageMaps();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _onBack = () => {
    const { history } = this.props;

    history.goBack();
  };

  _scroll1 = () => {
    window.scrollTo(0, 700);
  };
  _scroll2 = () => {
    window.scrollTo(0, 1600);
  };
  _scroll3 = () => {
    window.scrollTo(0, 3500);
  };

  _mscroll1 = () => {
    //alert(0)
    //document.getElementById('root').scrollTo(0, 0)
    window.scrollTo(0, 800);
  };
  _mscroll2 = () => {
    window.scrollTo(0, 200);
  };
  _mscroll3 = () => {
    window.scrollTo(0, 500);
  };
  _bang = () => {
    window.open("https://shop.aniplustv.com/cafe/25?i=0", "", "");
  };
  _king = () => {
    window.open("https://shop.aniplustv.com/cafe/24", "", "");
  };
  _mbang = () => {
    window.open("https://mshop.aniplustv.com/cafe/25?i=0", "", "");
  };
  _mking = () => {
    window.open("https://mshop.aniplustv.com/cafe/24", "", "");
  };
  _changeTab = (tabIndex) => {
    this.setState({
      tabIndex,
    });
  };
  _map = () => {
    const { tabIndex } = this.state;

    if (tabIndex === 0) {
      window.open(
        "https://map.naver.com/v5/search/%EB%A9%94%EA%B0%80%EB%B0%95%EC%8A%A4%20%EC%A4%91%EC%95%99%EB%A1%9C%EC%A0%90/place/1498927482?c=14184513.9621432,4345939.5881539,15,0,0,0,dh&placePath=%3Fentry%253Dbmp",
        "",
        ""
      );
    } else if (tabIndex === 2) {
      window.open(
        "https://map.naver.com/v5/entry/address/14128060.011958305,4184019.4682137705,%EA%B4%91%EC%A3%BC%EA%B4%91%EC%97%AD%EC%8B%9C%20%EB%8F%99%EA%B5%AC%20%EC%B6%A9%EC%9E%A5%EB%A1%9C%EC%95%88%EA%B8%B8%2012%20%EB%A1%AF%EB%8D%B0%EC%8B%9C%EB%84%A4%EB%A7%88%20%EC%B6%A9%EC%9E%A5%EB%A1%9C%EC%A0%90?c=14128051.6811416,4184025.7909591,19,0,0,0,dh",
        "",
        ""
      );
    }
  };
  _more = () => {
    isMobile
      ? window.open("https://mshop.aniplustv.com/cafe/25?i=1", "", "")
      : window.open("https://shop.aniplustv.com/cafe/25?i=1", "", "");
  };
  _more1 = () => {
    isMobile
      ? window.open("https://mshop.aniplustv.com/cafe/26?i=2", "", "")
      : window.open("https://shop.aniplustv.com/cafe/26?i=2", "", "");
  };
  _more2 = () => {
    isMobile
      ? window.open("https://mshop.aniplustv.com/self", "", "")
      : window.open("https://shop.aniplustv.com/self", "", "");
  };
  render() {
    const { tabIndex } = this.state;

    return (
      <Fragment>
        <div className="event_head">
          <h3>애니플러스 지점 오픈 이벤트</h3>
          <button
            type="button"
            className="btnClose"
            onClick={this._onBack}
            style={{ pointer: "cursor" }}
          >
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <div className="event_shopOp">
            {tabIndex === 0 ? (
              <div className="sticky">
                <a href="#link1">
                  <img
                    src="/img/event/event210629/quickmenu01.png"
                    alt="한정특전"
                  />
                </a>
                <a href="#link2">
                  <img
                    src="/img/event/event210629/quickmenu02.png"
                    alt="극장특전"
                  />
                </a>
                <a href="#link3">
                  <img
                    src="/img/event/event210629/quickmenu03.png"
                    alt="생일굿즈"
                  />
                </a>
                <a href="#link4">
                  <img
                    src="/img/event/event210629/quickmenu04.png"
                    alt="무료배포"
                  />
                </a>
                <a href="#link5">
                  <img
                    src="/img/event/event210629/quickmenu05.png"
                    alt="댓글"
                  />
                </a>
              </div>
            ) : tabIndex === 2 ? (
              <div className="sticky">
                <img src="/img/event/event210819/quickmenu_top.png" />
                <a href="#link11">
                  <img
                    src="/img/event/event210819/quickmenu01.png"
                    alt="한정특전"
                  />
                </a>
                <a href="#link22">
                  <img
                    src="/img/event/event210819/quickmenu02.png"
                    alt="극장특전"
                  />
                </a>
                <a href="#link33">
                  <img
                    src="/img/event/event210819/quickmenu03.png"
                    alt="생일굿즈"
                  />
                </a>
                <a href="#link44">
                  <img
                    src="/img/event/event210819/quickmenu04.png"
                    alt="무료배포"
                  />
                </a>
                <a href="#link55">
                  <img
                    src="/img/event/event210819/quickmenu05.png"
                    alt="댓글"
                  />
                </a>
                <img src="/img/event/event210819/quickmenu_btm.png" />
              </div>
            ) : null}

            <div className="tabMenu">
              <a
                onClick={() => this._changeTab(2)}
                className={tabIndex === 2 ? "active" : null}
                style={{ cursor: "pointer" }}
              >
                광주 충장로점
                <span>8월 19일 오픈!</span>
              </a>
              <a
                onClick={() => this._changeTab(0)}
                className={tabIndex === 0 ? "active" : null}
                style={{ cursor: "pointer" }}
              >
                대전 중앙로점
                <span>7월 9일 첫 오픈 이벤트!</span>
              </a>
              <a
                onClick={() => this._changeTab(1)}
                className={tabIndex === 1 ? "active" : null}
                style={{ cursor: "pointer" }}
              >
                서울 합정점
                <span>6월 11일 리뉴얼 오픈 이벤트!</span>
              </a>
            </div>

            {tabIndex === 0 ? (
              <Fragment>
                <div className="eventMain">
                  <a
                    onClick={this._map}
                    className="location"
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src="/img/event/event210629/daejeon_btn.png"
                      alt="찾아오시는 길"
                    />
                  </a>
                  <img
                    src="/img/event/event210629/daejeon_img01.png"
                    className="img_web"
                  />
                  <img
                    src="/img/event/event210629/m_daejeon_img01.png"
                    className="img_m"
                  />
                </div>
                <div className="eventBody">
                  <div className="event">
                    {isMobile ? (
                      <Fragment>
                        <div className="link">
                          <a onClick={this._more} alt="자세히 보기"></a>
                        </div>
                        <img
                          src="/img/event/event210629/m_daejeon_imgFull.png"
                          className="img_m"
                          useMap="#FPMap1"
                        />

                        <map name="FPMap1">
                          <area
                            onClick={this._more}
                            shape="rect"
                            coords="196, 520, 465, 583"
                          />
                        </map>
                      </Fragment>
                    ) : (
                      <Fragment>
                        <div className="link">
                          <a href="#" name="link1" alt="자세히 보기"></a>
                        </div>
                        <img
                          src="/img/event/event210629/daejeon_list01.png"
                          className="img_web"
                          useMap="#FPMap0"
                        />
                        <div className="link">
                          <a href="#" name="link2" alt="자세히 보기"></a>
                        </div>
                        <img
                          src="/img/event/event210629/daejeon_list02.png"
                          className="img_web"
                        />
                        <div className="link">
                          <a href="#" name="link3" alt="자세히 보기"></a>
                        </div>
                        <img
                          src="/img/event/event210629/daejeon_list03.jpg"
                          className="img_web"
                        />
                        <div className="link">
                          <a href="#" name="link4" alt="자세히 보기"></a>
                        </div>
                        <img
                          src="/img/event/event210629/daejeon_list04.jpg"
                          className="img_web"
                        />
                        <div className="link">
                          <a href="#" name="link5" alt="자세히 보기"></a>
                        </div>

                        <map name="FPMap0">
                          <area
                            onClick={this._more}
                            shape="rect"
                            coords="1193, 616, 1459, 680"
                            style={{ cursor: "pointer" }}
                          />
                        </map>
                      </Fragment>
                    )}
                  </div>
                </div>
              </Fragment>
            ) : tabIndex === 2 ? (
              <Fragment>
                <div className="eventMain">
                  <a
                    onClick={this._map}
                    className="location"
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src="/img/event/event210819/btn.png"
                      alt="찾아오시는 길"
                    />
                  </a>
                  <img
                    src="/img/event/event210819/op_top.png"
                    className="img_web"
                  />
                  <img
                    src="/img/event/event210819/m_op_top.png"
                    className="img_m"
                  />
                  <video
                    src="/img/event/event210819/gochiusa_bloom_op.mp4"
                    className="video"
                    muted="muted"
                    autoPlay
                    loop
                  ></video>
                </div>
                <div className="eventBody">
                  <div className="event">
                    <a href="#" name="link11" alt="자세히 보기"></a>
                    <img
                      src="/img/event/event210819/img01.png"
                      className="img_web"
                      useMap="#FPMap0"
                    />
                    <img
                      src="/img/event/event210819/m_img01.png"
                      className="img_m"
                      useMap="#FPMap2"
                    />
                    <map name="FPMap0">
                      <area
                        onClick={this._more1}
                        shape="rect"
                        coords="1224, 638, 1464, 693"
                        style={{ cursor: "pointer" }}
                      />
                    </map>
                    <map name="FPMap2">
                      <area
                        onClick={this._more1}
                        shape="rect"
                        coords="228, 508, 479, 572"
                        style={{ cursor: "pointer" }}
                      />
                    </map>
                  </div>
                  <div className="event">
                    <a href="#" name="link22" alt="자세히 보기"></a>
                    <img
                      src="/img/event/event210819/img02.png"
                      className="img_web"
                      useMap="#FPMap1"
                    />
                    <img
                      src="/img/event/event210819/m_img02.png"
                      className="img_m"
                      useMap="#FPMap3"
                    />
                    <map name="FPMap1">
                      <area
                        onClick={this._more2}
                        shape="rect"
                        coords="193, 629, 459, 705"
                        style={{ cursor: "pointer" }}
                      />
                    </map>
                    <map name="FPMap3">
                      <area
                        onClick={this._more2}
                        shape="rect"
                        coords="225, 465, 477, 526"
                        style={{ cursor: "pointer" }}
                      />
                    </map>
                  </div>
                  <div className="event" name="link33">
                    <a href="#" name="link33" alt="자세히 보기"></a>
                    <img
                      src="/img/event/event210819/img03.png"
                      className="img_web"
                    />
                    <img
                      src="/img/event/event210819/m_img03.png"
                      className="img_m"
                    />
                  </div>
                  <div className="event" name="link44">
                    <a href="#" name="link44" alt="자세히 보기"></a>
                    <img
                      src="/img/event/event210819/img04.png"
                      className="img_web"
                    />
                    <img
                      src="/img/event/event210819/m_img04.png"
                      className="img_m"
                    />
                  </div>
                </div>
              </Fragment>
            ) : tabIndex === 1 ? (
              isMobile ? (
                <Fragment>
                  <img
                    src="/img/event/event210602/M_event_202106.png"
                    useMap="#Map1"
                  />
                  <map name="Map1">
                    <area
                      onClick={this._mscroll1}
                      style={{ cursor: "pointer" }}
                      shape="rect"
                      coords="1, 533, 219, 675"
                    />
                    <area
                      onClick={this._mscroll2}
                      style={{ cursor: "pointer" }}
                      shape="rect"
                      coords="221, 535, 476, 670"
                    />
                    <area
                      onClick={this._mscroll3}
                      style={{ cursor: "pointer" }}
                      shape="rect"
                      coords="483, 538, 704, 669"
                    />
                    <area
                      onClick={this._mbang}
                      style={{ cursor: "pointer" }}
                      shape="rect"
                      coords="63, 1367, 326, 1432"
                    />
                    <area
                      onClick={this._mking}
                      style={{ cursor: "pointer" }}
                      shape="rect"
                      coords="382, 1369, 646, 1434"
                    />
                  </map>
                </Fragment>
              ) : (
                <Fragment>
                  <img
                    src="/img/event/event210602/W_event_202106.png"
                    useMap="#Map1"
                  />
                  <map name="Map1">
                    <area
                      onClick={this._scroll1}
                      style={{ cursor: "pointer" }}
                      shape="rect"
                      coords="181, 533, 623, 675"
                    />
                    <area
                      onClick={this._scroll2}
                      style={{ cursor: "pointer" }}
                      shape="rect"
                      coords="623, 534, 1085, 674"
                    />
                    <area
                      onClick={this._scroll3}
                      style={{ cursor: "pointer" }}
                      shape="rect"
                      coords="1084, 536, 1522, 674"
                    />
                    <area
                      onClick={this._bang}
                      style={{ cursor: "pointer" }}
                      shape="rect"
                      coords="379, 1318, 647, 1483"
                    />
                    <area
                      onClick={this._king}
                      style={{ cursor: "pointer" }}
                      shape="rect"
                      coords="1052, 1317, 1319, 1486"
                    />
                  </map>
                </Fragment>
              )
            ) : null}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202106_shop));
